<template>
  <div class="grid-view" style="margin-top: 10px;">
    <el-form :inline="true" label-width="70px" label-position="left">
      <el-row>
        <el-col>
          <el-form-item>
            <el-checkbox v-model="cbUseParent">{{ $t('CargoMsg.Cargo_GeneralSettings') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form :inline="true" label-width="70px" label-position="left">
      <el-row>
        <el-col>
          <el-form-item :label="$t('CargoMsg.Cargo_ControlMode2')" label-width="120px">
            <el-radio-group v-model="rbgMode">
              <el-radio :label="2">{{ $t('CargoMsg.Cargo_ReminderMode') }}</el-radio>
              <el-radio :label="1">{{ $t('CargoMsg.Cargo_LockMode') }}</el-radio>
            </el-radio-group>
            <el-tag size="medium" type="success" style="margin-left: 15px;">
              {{ rbgMode === 2 ? this.$t('CargoMsg.Cargo_CreditOnlyReminder') : this.$t('CargoMsg.Cargo_CreditLimitExceededApproval') }}
            </el-tag>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="$t('SystemMaintenance.DesignatedCargoControlRange')" label-width="120px">
            <el-checkbox v-model="form.ncCustomerId">{{ $t('CargoMsg.Cargo_AuthorizedClient') }}</el-checkbox>
            <el-checkbox v-model="form.ncDesignationAgent">{{ $t('CargoMsg.Cargo_NominatedAgent') }}</el-checkbox>
            <el-checkbox v-model="form.ncReceivableChargeAccountId">{{ $t('SystemMaintenance.AccountsReceivableSettlementUnits') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="$t('SystemMaintenance.RangeOfSelfPickupControl')" label-width="120px">
            <el-checkbox v-model="form.scCustomerId">{{ $t('CargoMsg.Cargo_AuthorizedClient') }}</el-checkbox>
            <el-checkbox v-model="form.scDesignationAgent">{{ $t('CargoMsg.Cargo_NominatedAgent') }}</el-checkbox>
            <el-checkbox v-model="form.scReceivableChargeAccountId">{{ $t('SystemMaintenance.AccountsReceivableSettlementUnits') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 5px;">
        <el-col>
          <el-form-item :label="$t('SystemMaintenance.WarningConfiguration')" label-width="120px">
            <span>{{ $t('CargoMsg.Cargo_Limit') }}</span>
            <el-input-number v-model="form.creditLimitAlarmRatio" :min="0" :max="99" :precision="0" :controls="false" style="width: 50px;margin-left: 2px;" />
            <span>
              %
              <el-tooltip placement="bottom" :content="$t('SystemMaintenance.UsersAlertNotifyAfterUsingXX')">
                <i class="el-icon-question" style="font-size:16px;vertical-align: text-bottom;" />
              </el-tooltip>
            </span>
            <span style="margin-left: 15px;">{{ $t('CargoMsg.Cargo_AccountPeriod') }}</span>
            <el-input-number v-model="form.warnDateLimit" :min="0" :precision="0" :controls="false" style="width: 50px;margin-left: 2px;" />
            <span>
              {{ $t('CargoMsg.Cargo_Days') }}
              <el-tooltip placement="bottom" :content="$t('SystemMaintenance.UsersAlertNotifyBeforeExpireDate')">
                <i class="el-icon-question" style="font-size:16px;vertical-align: text-bottom;" />
              </el-tooltip>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--遮罩-->
    <div v-if="cbUseParent" style="position: absolute; top: 40px; left: 0;right: 0;bottom: 0; background-color: rgba(0,0,0,.2); cursor: not-allowed; z-index: 10" />
    <div style="display: flex; flex: 1;">
      <div style="flex: 1;">
        <span class="title">{{ $t('CargoMsg.Cargo_Notification') }}</span>
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="adAlert.gridOptions"
          :column-defs="adAlertColumnDefs"
          :row-data="adAlert.rowData"
          style="height: calc(100% - 30px)"
        />
      </div>
      <div style="flex: 1; margin-left: 5px;">
        <span class="title">{{ $t('CargoMsg.Cargo_LockingControl') }}</span>
        <div class="tabs-container" style="height: calc(100% - 30px)">
          <el-tabs v-show="tnLock1" v-model="activeTabNameSE" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :key="1" :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingSE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingSE.gridOptions"
                :column-defs="dgOrderTakingSEColumnDefs"
                :row-data="dgOrderTakingSE.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :key="2" :label="$t('CargoMsg.Cargo_Print')" name="dgPrint">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgPrint.gridOptions"
                :column-defs="dgPrintColumnDefs"
                :row-data="dgPrint.rowData"
                style="height: 100%;"
              />
            </el-tab-pane>
            <el-tab-pane :key="3" label="EDI" name="dgEDI">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgEDI.gridOptions"
                :column-defs="dgEDIColumnDefs"
                :row-data="dgEDI.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :key="4" :label="$t('CargoMsg.Cargo_BLRelease')" name="dgCargoDocSE" class="section">
              <!--              <cargo-ag-grid-->
              <!--                :show-side-bar="false"-->
              <!--                :grid-options="dgCargoDocSE.gridOptions"-->
              <!--                :column-defs="dgCargoDocSEColumnDefs"-->
              <!--                :row-data="dgCargoDocSE.rowData"-->
              <!--                style="height: 100%"-->
              <!--              />-->
              <template class="section">
                <el-table :data="dgCargoDocSE.tableData" style="width: 100%" border stripe class="section ">
                  <el-table-column prop="typeName" :label="$t('CargoMsg.Cargo_Type')" width="300px" />
                  <el-table-column prop="date" :label="$t('CargoMsg.Cargo_Operation')" width="300px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.type" clearable style="width: 260px;">
                        <el-option :label="$t('CargoMsg.Cargo_NoLock')" value="0" />
                        <el-option v-if="scope.row.typeName === '只有HBL'" label="只有HBL扣HBL" value="1" />
                        <el-option v-if="scope.row.typeName === '只有MBL'" label="只有MBL扣MBL" value="1" />
                        <el-option v-if="scope.row.typeName === 'HBL & MBL同时有'" label="HBL、MBL同时扣" value="1" />
                        <el-option v-if="scope.row.typeName === 'HBL & MBL同时有'" label="只扣HBL不扣MBL" value="2" />
                        <el-option v-if="scope.row.typeName === 'HBL & MBL同时有'" label="不扣HBL只扣MBL" value="3" />
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-show="tnLock2" v-model="activeTabNameAE" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :key="11" :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingAE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingAE.gridOptions"
                :column-defs="dgOrderTakingAEColumnDefs"
                :row-data="dgOrderTakingAE.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :key="22" :label="$t('CargoMsg.Cargo_Print')" name="dgPrintAE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgPrintAE.gridOptions"
                :column-defs="dgPrintAEColumnDefs"
                :row-data="dgPrintAE.rowData"
                style="height: 100%;"
              />
            </el-tab-pane>
            <el-tab-pane :key="33" :label="$t('CargoMsg.Cargo_DocumentCirculation')" name="dgFile">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgFile.gridOptions"
                :column-defs="dgFileColumnDefs"
                :row-data="dgFile.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-show="tnLock3" v-model="activeTabNameSI" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :key="111" :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingSI">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingSI.gridOptions"
                :column-defs="dgOrderTakingSIColumnDefs"
                :row-data="dgOrderTakingSI.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-show="tnLock4" v-model="activeTabNameAI" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :key="1" :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingAI">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingAI.gridOptions"
                :column-defs="dgOrderTakingAIColumnDefs"
                :row-data="dgOrderTakingAI.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-show="tnLock5" v-model="activeTabNameRE" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingRE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingRE.gridOptions"
                :column-defs="dgOrderTakingREColumnDefs"
                :row-data="dgOrderTakingRE.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_Print')" name="dgPrintRE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgPrintRE.gridOptions"
                :column-defs="dgPrintREColumnDefs"
                :row-data="dgPrintRE.rowData"
                style="height: 100%;"
              />
            </el-tab-pane>
            <el-tab-pane label="EDI" name="dgEDIRE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgEDIRE.gridOptions"
                :column-defs="dgEDIRE.columnDefs"
                :row-data="dgEDIRE.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_BLRelease')" name="dgCargoDocRE" class="section">
              <template class="section">
                <el-table :data="dgCargoDocRE.tableData" style="width: 100%" border stripe class="section ">
                  <el-table-column prop="typeName" :label="$t('CargoMsg.Cargo_Type')" width="300px" />
                  <el-table-column prop="date" :label="$t('CargoMsg.Cargo_Operation')" width="300px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.type" clearable style="width: 260px;" />
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-show="tnLock6" v-model="activeTabNameRI" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingRI">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingRI.gridOptions"
                :column-defs="dgOrderTakingRIColumnDefs"
                :row-data="dgOrderTakingRI.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_Print')" name="dgPrintRI">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgPrintRI.gridOptions"
                :column-defs="dgPrintRIColumnDefs"
                :row-data="dgPrintRI.rowData"
                style="height: 100%;"
              />
            </el-tab-pane>
            <el-tab-pane label="EDI" name="dgEDIRI">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgEDIRI.gridOptions"
                :column-defs="dgEDIRI.columnDefs"
                :row-data="dgEDIRI.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_BLRelease')" name="dgCargoDocRI" class="section">
              <template class="section">
                <el-table :data="dgCargoDocRI.tableData" style="width: 100%" border stripe class="section ">
                  <el-table-column prop="typeName" :label="$t('CargoMsg.Cargo_Type')" width="300px" />
                  <el-table-column prop="date" :label="$t('CargoMsg.Cargo_Operation')" width="300px">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.type" clearable style="width: 260px;" />
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-show="tnLock7" v-model="activeTabNameIE" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_OrderReceiving')" name="dgOrderTakingIE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgOrderTakingIE.gridOptions"
                :column-defs="dgOrderTakingIEColumnDefs"
                :row-data="dgOrderTakingIE.rowData"
                style="height: 100%"
              />
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_Print')" name="dgPrintIE">
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="dgPrintIE.gridOptions"
                :column-defs="dgPrintIEColumnDefs"
                :row-data="dgPrintIE.rowData"
                style="height: 100%;"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getConfig } from '@/utils/cacheManager'
import { getUuid } from '@/utils'
import { queryTemplatesByTypeMuti } from '@/api/sysManage/baseConfig/template'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import { saveCreditConfig } from '@/api/sysManage/baseConfig/configDef'
import { getOfficeConfigList } from '@/api/user'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getCreditConfig } from '@/api/sysManage/creditConfig'

export default {
  name: 'CreditConfig',
  components: {
  },
  props: {
    lob: { type: String, required: true, default: 'SE' }
  },
  data() {
    return {
      rbgMode: 2,
      cbUseParent: false,
      types: [],
      adAlert: {
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          singleClickEdit: true,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Event'),
            checkboxSelection: false,
            field: 'name',
            colId: 'name',
            flex: 1,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                return params.value
              }
            }
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      activeTabNameSE: 'dgOrderTakingSE',
      activeTabNameAE: 'dgOrderTakingAE',
      activeTabNameSI: 'dgOrderTakingSI',
      activeTabNameAI: 'dgOrderTakingAI',
      activeTabNameRE: 'dgOrderTakingRE',
      activeTabNameRI: 'dgOrderTakingRI',
      activeTabNameIE: 'dgOrderTakingIE',
      dgOrderTakingSE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgPrint: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgEDI: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: 'EDI', field: 'edi', colId: 'edi', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1 }
        ],
        rowData: []
      },
      dgCargoDocSE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          },
          onRowClicked: this.onRowClickedCargoDocSE
        },
        tableData: [
          {
            typeName: '只有HBL',
            type: '0'
          },
          {
            typeName: '只有MBL',
            type: '0'
          },
          {
            typeName: 'HBL & MBL同时有',
            type: '0'
          }
        ],
        rowData: []
      },
      dgOrderTakingAE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1 }
        ],
        rowData: []
      },
      dgPrintAE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_PrintTemplate'), field: 'template', colId: 'template', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1 }
        ],
        rowData: []
      },
      dgFile: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'edi', colId: 'edi', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1 }
        ],
        rowData: []
      },
      dgOrderTakingSI: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1 }
        ],
        rowData: []
      },
      dgOrderTakingAI: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1 }
        ],
        rowData: []
      },
      dgOrderTakingRE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgPrintRE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgEDIRE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: 'EDI', field: 'edi', colId: 'edi', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1 }
        ],
        rowData: []
      },
      dgCargoDocRE: {
        tableData: []
      },
      dgOrderTakingRI: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgPrintRI: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgEDIRI: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        columnDefs: [
          { headerName: 'EDI', field: 'edi', colId: 'edi', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1 }
        ],
        rowData: []
      },
      dgCargoDocRI: {
        tableData: []
      },
      dgOrderTakingIE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      dgPrintIE: {
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor
          }
        },
        rowData: []
      },
      alertSetting: [],
      printSetting: [],
      printSettingAE: [],
      printSettingRE: [],
      printSettingRI: [],
      printSettingIE: [],
      ediSetting: [],
      fileSetting: [],
      orderTakingSE: [],
      orderTakingAE: [],
      orderTakingSI: [],
      orderTakingAI: [],
      orderTakingRE: [],
      orderTakingRI: [],
      orderTakingIE: [],
      cargoDocSE: [],
      vgLock: false,
      tnLock1: false,
      tnLock2: false,
      tnLock3: false,
      tnLock4: false,
      tnLock5: false,
      tnLock6: false,
      tnLock7: false,
      configMap: null,
      configKeyMap: {}, // 保存时使用
      notifyTypes: [{ code: '0', name: this.$t('CargoMsg.Cargo_EmailsAndReminders') }, { code: '1', name: this.$t('CargoMsg.Cargo_Email2') }, { code: '2', name: this.$t('CargoMsg.Cargo_Prompt') }, { code: '3', name: this.$t('CargoMsg.Cargo_None') }], // 通知方式
      forewarningNotifyTypes: [{ code: '1', name: this.$t('CargoMsg.Cargo_Email2') }, { code: '3', name: this.$t('CargoMsg.Cargo_None') }], // 通知方式
      controlTypes: [{ code: '0', name: this.$t('CargoMsg.Cargo_LockAfterSaving') }, { code: '1', name: this.$t('CargoMsg.Cargo_CannotBeSaved') }], // 控制方式
      form: {}
    }
  },
  computed: {
    types1() {
      return [{ code: '0', name: '不扣单' }, { code: '1', name: '只有HBL扣HBL' }]
    }, // 控制方式
    types2() {
      return [{ code: '0', name: '不扣单' }, { code: '1', name: '只有MBL扣MBL' }]
    }, // 控制方式
    types3() {
      return [{ code: '0', name: this.$t('CargoMsg.Cargo_NoLock') }, { code: '1', name: 'HBL、MBL同时扣' }, { code: '2', name: '只扣HBL不扣MBL' }, { code: '3', name: '不扣HBL只扣MBL' }]
    }, // 控制方式
    adAlertColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_NotificationObject'), field: 'target', colId: 'target', flex: 1,
          valueFormatter: (params) => {
            return this.alertTargetLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_NotificationMethod'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertTypeFunction(params.value)
          },
          editable: (params) => {
            if (!params.data || !params.data.path) return false
            return params.data.path.toString().indexOf(',') !== -1
          },
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: (params) => ({
            options: params.data.name === this.$t('CargoMsg.Cargo_PaymentPeriodForewarning') ? this.forewarningNotifyTypes : this.notifyTypes,
            tagName: 'name',
            tagValue: 'code'
          })
        }
      ]
    },
    dgOrderTakingSEColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    },
    dgPrintColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_PrintTemplate'), field: 'template', colId: 'template', flex: 1,
          valueFormatter: (params) => {
            return this.templateTypeFunction(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgEDIColumnDefs() {
      return [
        { headerName: 'EDI', field: 'edi', colId: 'edi', flex: 1,
          valueFormatter: (params) => {
            return this.ediTypeFunction(params.data)
          } },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgCargoDocSEColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_Type'), field: 'typeName', colId: 'typeName', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.cargoDocTypeLabelFunc(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.types,
            tagName: 'name',
            tagValue: 'code'
          }
        }
      ]
    },
    dgOrderTakingAEColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    },
    dgPrintAEColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_PrintTemplate'), field: 'template', colId: 'template', flex: 1,
          valueFormatter: (params) => {
            return this.templateAETypeFunction(params.data)
          } },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgPrintREColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_PrintTemplate'), field: 'template', colId: 'template', flex: 1,
          valueFormatter: (params) => {
            return this.templateAETypeFunction(params.data)
          } },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgPrintRIColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_PrintTemplate'), field: 'template', colId: 'template', flex: 1,
          valueFormatter: (params) => {
            return this.templateAETypeFunction(params.data)
          } },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgPrintIEColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_PrintTemplate'), field: 'template', colId: 'template', flex: 1,
          valueFormatter: (params) => {
            return this.templateIETypeFunction(params.data)
          } },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgFileColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'edi', colId: 'edi', flex: 1,
          valueFormatter: (params) => {
            return this.fileTypeFunction(params.data)
          } },
        { headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'selected', colId: 'selected', flex: 1,
          valueFormatter: (params) => {
            return this.booleanColumnLabelFunc(params.data)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox'
          }}
      ]
    },
    dgOrderTakingSIColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    },
    dgOrderTakingAIColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    },
    dgOrderTakingREColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    },
    dgOrderTakingRIColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    },
    dgOrderTakingIEColumnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_ControlObject'), field: 'controlObject', colId: 'controlObject', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_ControlMode'), field: 'type', colId: 'type', flex: 1,
          valueFormatter: (params) => {
            return this.alertControlTypeFunction(params.data)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: this.controlTypes,
            tagName: 'name',
            tagValue: 'code'
          }}
      ]
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadCreditConfigForm()
      }
    }
  },
  created() {
    this.updateView()
  },
  methods: {
    handleClick() {

    },
    // 保存
    onSave(saveObj = null) {
      const saveItems = [] // 保存项
      if (saveObj) saveItems.push(saveObj)

      let value = ''
      // 处理通知提醒
      const adAlerts = this.adAlert.rowData
      if (adAlerts.length > 0) {
        for (const adAlert of adAlerts) {
          if (!adAlert.uuid || !adAlert.path) continue
          value = ''
          const name = adAlert.config
          if (adAlert.children) { // 父级，说明有孩子
            for (const child of adAlerts) {
              if (!child.uuid || !child.path) continue
              const childPath = (adAlert.uuid + ',' + child.uuid)
              if (child.uuid && child.path === childPath) {
                value += (child.target + '-' + child.type + ',')
              }
            }
            value = value.slice(0, -1)
          } else {
            // 将二级节点排除掉
            if (adAlert.path && adAlert.path.indexOf(',') > -1) {
              continue
            }
            value = (adAlert.target + '-' + adAlert.type)
          }
          saveItems.push({ name: name, value: value })
        }
      }

      // 以下是锁定控制的保存==============================
      // 海出
      if (this.tnLock1) {
        value = ''
        // 锁定控制-打印
        const dgPrints = this.dgPrint.rowData
        if (dgPrints.length > 0) {
          for (const dgPrint of dgPrints) {
            const block = dgPrint.selected ? '1' : '0'
            value += (dgPrint.template + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockPrint', value: value })
        }

        value = ''
        // 锁定控制-EDI
        const dgEDIs = this.dgEDI.rowData
        if (dgEDIs.length > 0) {
          for (const dgEDI of dgEDIs) {
            const block = dgEDI.selected ? '1' : '0'
            value += (dgEDI.edi + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockEDI', value: value })
        }
      }

      // 空出
      if (this.tnLock2) {
        value = ''
        // 锁定控制-打印
        const dgPrintAEs = this.dgPrintAE.rowData
        if (dgPrintAEs.length > 0) {
          for (const dgPrintAE of dgPrintAEs) {
            const block = dgPrintAE.selected ? '1' : '0'
            value += (dgPrintAE.template + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockPrintAE', value: value })
        }

        value = ''
        // 锁定控制-单证
        const dgFiles = this.dgFile.rowData
        if (dgFiles.length > 0) {
          for (const dgFile of dgFiles) {
            const block = dgFile.selected ? '1' : '0'
            value += (dgFile.file + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockFile', value: value })
        }
      }

      // 铁出
      if (this.tnLock5) {
        value = ''
        // 锁定控制-打印
        const dgPrintREs = this.dgPrintRE.rowData
        if (dgPrintREs.length > 0) {
          for (const dgPrintRE of dgPrintREs) {
            const block = dgPrintRE.selected ? '1' : '0'
            value += (dgPrintRE.template + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockPrintRE', value: value })
        }
      }

      // 铁进
      if (this.tnLock6) {
        value = ''
        // 锁定控制-打印
        const dgPrintRIs = this.dgPrintRI.rowData
        if (dgPrintRIs.length > 0) {
          for (const dgPrintRI of dgPrintRIs) {
            const block = dgPrintRI.selected ? '1' : '0'
            value += (dgPrintRI.template + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockPrintRI', value: value })
        }
      }

      // 综合物流
      if (this.tnLock7) {
        value = ''
        // 锁定控制-打印
        const dgPrintIEs = this.dgPrintIE.rowData
        if (dgPrintIEs.length > 0) {
          for (const dgPrintRI of dgPrintIEs) {
            const block = dgPrintRI.selected ? '1' : '0'
            value += (dgPrintRI.template + '-' + block + ',')
          }
          value = value.slice(0, -1)
          saveItems.push({ name: 'creditBlockPrintIE', value: value })
        }
      }
      // 使用总公司信控
      saveItems.push({ name: ('useParentCreditSetting' + this.lob), value: this.cbUseParent ? '1' : '0' })
      // 控制模式
      saveItems.push({ name: ('creditMode' + this.lob), value: this.rbgMode.toString() })

      // 保存控制类型
      if (this.dgOrderTakingSE.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeSE', value: this.dgOrderTakingSE.rowData[0].type })
      }
      if (this.dgOrderTakingAE.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeAE', value: this.dgOrderTakingAE.rowData[0].type })
      }
      if (this.dgOrderTakingSI.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeSI', value: this.dgOrderTakingSI.rowData[0].type })
      }
      if (this.dgOrderTakingAI.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeAI', value: this.dgOrderTakingAI.rowData[0].type })
      }
      if (this.dgOrderTakingRE.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeRE', value: this.dgOrderTakingRE.rowData[0].type })
      }
      if (this.dgOrderTakingRI.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeRI', value: this.dgOrderTakingRI.rowData[0].type })
      }
      if (this.dgOrderTakingIE.rowData.length > 0) {
        saveItems.push({ name: 'creditControlTypeIE', value: this.dgOrderTakingIE.rowData[0].type })
      }

      if (this.dgCargoDocSE && this.dgCargoDocSE.rowData.length > 0) {
        this.dgCargoDocSE.tableData.forEach((cargoDoc, index) => {
          if (cargoDoc.typeName === '只有HBL') {
            saveItems.push({ name: 'creditCargoDocTypeHBLSE', value: cargoDoc.type })
          } else if (cargoDoc.typeName === '只有MBL') {
            saveItems.push({ name: 'creditCargoDocTypeMBLSE', value: cargoDoc.type })
          } else if (cargoDoc.typeName === 'HBL & MBL同时有') {
            saveItems.push({ name: 'creditCargoDocTypeHBLAndMBLSE', value: cargoDoc.type })
          }
        })
      }
      if (saveItems.length > 0) {
        const configs = []
        for (const item of saveItems) {
          const k = this.configKeyMap[item.name]
          if (k) {
            const config = { key: k.key, name: item.name, value: item.value, useDefault: k.useDefault }
            configs.push(config)
          }
        }
        // console.log('configs==============', configs)
        this.loading = getLoading()
        saveCreditConfig({
          configDef: { configs: configs, officeId: this.$store.getters.currentOfficeId },
          creditConfig: this.form
        }).then(res => {
          this.form = res.data
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.loadConfig()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    async updateView(configMap = null, result = []) {
      await this.loadConfig(configMap, result)
      this.controlDisplay()
      this.cbUseParent = this.useParentCreditSetting()
      this.rbgMode = this.creditMode()
      this.creditAlertRoles()
      await this.loadCreditConfigForm()
    },
    // 加载最新配置
    async loadConfig(configMap = null, result = []) {
      this.loading = getLoading()
      const officeId = this.$store.getters.currentOfficeId
      if (!configMap) {
        await getConfig(officeId, true).then(data => {
          this.configMap = data
        }).catch(() => {
          this.loading.close()
        })
      }
      if (!result || result.length === 0) {
        await getOfficeConfigList({ officeId }).then(res => {
          this.setOfficeConfigList(res.data)
        }).catch(() => {
          this.loading.close()
        })
      } else {
        this.setOfficeConfigList(result)
      }
      this.loading.close()
    },
    setOfficeConfigList(result) {
      if (result && result.length > 0) {
        let useDefault = false
        let key = ''
        let configName = ''
        for (const r of result) {
          if (r['configUuid']) {
            key = r['configUuid']
            useDefault = false
          } else {
            key = r['configDefUuid']
            useDefault = true
          }
          configName = r['configName'].toString().trim()
          if (configName === 'creditBlockPrintAE') {
            this.configMap['creditBlockPrintAEP'] = r['configParentValue'] ? r['configParentValue'] : r['configDefValue']
          }
          if (configName === 'creditModeAE') {
            this.configMap['creditModeAEP'] = r['configParentValue'] ? r['configParentValue'] : r['configDefValue']
          }
          this.configKeyMap[configName] = { key: key, useDefault: useDefault }
        }
      }
    },
    async loadCreditConfigForm() {
      const loading = getLoading4Cxt(this)
      try {
        await getCreditConfig({ officeId: this.$store.getters.currentOfficeId, lob: this.lob }).then(res => {
          this.form = res.data
        })
      } finally {
        loading.close()
      }
    },
    useParentCreditSetting() {
      if (this.configMap.has('useParentCreditSetting' + this.lob) && this.configMap.get('useParentCreditSetting' + this.lob)) {
        const useParentCreditSetting = this.configMap.get('useParentCreditSetting' + this.lob).toString().trim()
        return useParentCreditSetting === '1'
      }
      return false
    },
    onRowClickedCargoDocSE(e) {
      if (e.data) {
        const type = e.data.typeName
        switch (type) {
          case '只有HBL':
            this.types = this.types1
            break
          case '只有MBL':
            this.types = this.types2
            break
          case 'HBL & MBL同时有':
            this.types = this.types3
            break
        }
        this.dgCargoDocSE.gridOptions.api.refreshCells({ force: true })
      }
    },
    creditMode() {
      if (this.configMap.has('creditMode' + this.lob) && this.configMap.get('creditMode' + this.lob)) {
        const creditMode = this.configMap.get('creditMode' + this.lob).toString().trim()
        return creditMode === '2' ? 2 : 1
      }
      return 2
    },
    creditAlertRoles() {
      this.alertSetting = []
      this.printSetting = []
      this.printSettingAE = []
      this.printSettingRE = []
      this.printSettingRI = []
      this.printSettingIE = []
      this.ediSetting = []
      this.fileSetting = []
      let s = ''
      if (this.configMap.has('creditAlertJobLocked' + this.lob)) {
        s = this.configMap.get('creditAlertJobLocked' + this.lob)
        this.creditAlertRolesDataStruct(s, this.$t('CargoMsg.Cargo_JobSheetIsLocked'), 'creditAlertJobLocked' + this.lob)
      }
      if (this.configMap.has('creditAlertJobUnlocked' + this.lob)) {
        s = this.configMap.get('creditAlertJobUnlocked' + this.lob)
        this.creditAlertRolesDataStruct(s, this.$t('CargoMsg.Cargo_JobSheetIsUnlocked'), 'creditAlertJobUnlocked' + this.lob)
      }
      if (this.configMap.has('creditAlertOverflow' + this.lob)) {
        s = this.configMap.get('creditAlertOverflow' + this.lob)
        this.creditAlertRolesDataStruct(s, this.$t('CargoMsg.Cargo_CreditLimitExceeded2'), 'creditAlertOverflow' + this.lob)
      }
      if (this.configMap.has('creditAlertChangeSetting' + this.lob)) {
        s = this.configMap.get('creditAlertChangeSetting' + this.lob)
        this.creditAlertRolesDataStruct(s, this.$t('CargoMsg.Cargo_CreditLimitChanged'), 'creditAlertChangeSetting' + this.lob)
      }
      if (this.configMap.has('creditAlertTermForewarning' + this.lob)) {
        s = this.configMap.get('creditAlertTermForewarning' + this.lob)
        this.creditAlertRolesDataStruct(s, this.$t('CargoMsg.Cargo_CreditForewarning'), 'creditAlertTermForewarning' + this.lob, this.$t('CargoMsg.Cargo_PaymentPeriodForewarning'))
      }

      // 锁定控制 - 打印
      const setting = this.configMap.get('creditBlockPrint') ? this.configMap.get('creditBlockPrint').toString() : ''
      const a = setting.split(',')
      const templateTypes = []
      if (a && a.length > 0) {
        for (const o in a) {
          const lock = a[o].split('-')[1] === '1'
          const template = a[o].split('-')[0]
          const obj = { template: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.printSetting.push(obj)
          templateTypes.push(template)
        }
      }
      if (templateTypes.length > 0) {
        queryTemplatesByTypeMuti({ templateTypes: templateTypes, officeId: this.$store.getters.currentOfficeId }).then(res => {
          const result = res.data
          if (this.printSetting.length > 0) {
            for (const t in this.printSetting) {
              const curT = this.printSetting[t]
              if (curT) {
                const obj = result[curT.template]
                obj.uuid = getUuid()
                obj.path = curT.uuid + ',' + obj.uuid
                // this.printSetting.push(obj)
                curT.children = true // 说明有孩子
              }
            }
            this.dgPrint.rowData = this.printSetting
          }
        })
      }

      // 锁定控制 - 空出打印
      const settingAE = this.configMap.get('creditBlockPrintAE') ? this.configMap.get('creditBlockPrintAE').toString() : ''
      const aAE = settingAE.split(',')
      const templateTypesAE = []
      if (aAE && aAE.length > 0) {
        for (const o in aAE) {
          const lock = aAE[o].split('-')[1] === '1'
          const template = aAE[o].split('-')[0]
          const obj = { template: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.printSettingAE.push(obj)
          templateTypesAE.push(template)
        }
      }
      if (templateTypesAE.length > 0) {
        queryTemplatesByTypeMuti({ templateTypes: templateTypesAE, officeId: this.$store.getters.currentOfficeId }).then(res => {
          const result = res.data
          if (this.printSettingAE.length > 0) {
            for (const t in this.printSettingAE) {
              const curT = this.printSettingAE[t]
              if (curT) {
                const obj = result[curT.template]
                obj.uuid = getUuid()
                obj.path = curT.uuid + ',' + obj.uuid
                // this.printSettingAE.push(obj)
                curT.children = true // 说明有孩子
              }
            }
            this.dgPrintAE.rowData = this.printSettingAE
          }
        })
      }

      // 锁定控制 - 铁出打印
      const settingRE = this.configMap.get('creditBlockPrintRE') ? this.configMap.get('creditBlockPrintRE').toString() : ''
      const aRE = settingRE.split(',')
      const templateTypesRE = []
      if (aRE && aRE.length > 0) {
        for (const o in aRE) {
          const lock = aRE[o].split('-')[1] === '1'
          const template = aRE[o].split('-')[0]
          const obj = { template: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.printSettingRE.push(obj)
          templateTypesRE.push(template)
        }
      }
      if (templateTypesRE.length > 0) {
        queryTemplatesByTypeMuti({ templateTypes: templateTypesRE, officeId: this.$store.getters.currentOfficeId }).then(res => {
          const result = res.data
          if (this.printSettingRE.length > 0) {
            for (const t in this.printSettingRE) {
              const curT = this.printSettingRE[t]
              if (curT) {
                const obj = result[curT.template]
                obj.uuid = getUuid()
                obj.path = curT.uuid + ',' + obj.uuid
                curT.children = true // 说明有孩子
              }
            }
            this.dgPrintRE.rowData = this.printSettingRE
          }
        })
      }

      // 锁定控制 - 铁进打印
      const settingRI = this.configMap.get('creditBlockPrintRI') ? this.configMap.get('creditBlockPrintRI').toString() : ''
      const aRI = settingRI.split(',')
      const templateTypesRI = []
      if (aRI && aRI.length > 0) {
        for (const o in aRI) {
          const lock = aRI[o].split('-')[1] === '1'
          const template = aRI[o].split('-')[0]
          const obj = { template: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.printSettingRI.push(obj)
          templateTypesRI.push(template)
        }
      }
      if (templateTypesRI.length > 0) {
        queryTemplatesByTypeMuti({ templateTypes: templateTypesRI, officeId: this.$store.getters.currentOfficeId }).then(res => {
          const result = res.data
          if (this.printSettingRI.length > 0) {
            for (const t in this.printSettingRI) {
              const curT = this.printSettingRI[t]
              if (curT) {
                const obj = result[curT.template]
                obj.uuid = getUuid()
                obj.path = curT.uuid + ',' + obj.uuid
                curT.children = true // 说明有孩子
              }
            }
            this.dgPrintRI.rowData = this.printSettingRI
          }
        })
      }

      // 锁定控制 - 综合物流
      const settingIE = this.configMap.get('creditBlockPrintIE') ? this.configMap.get('creditBlockPrintIE').toString() : ''
      const aIE = settingIE.split(',')
      const templateTypesIE = []
      if (aIE && aIE.length > 0) {
        for (const o in aIE) {
          const lock = aIE[o].split('-')[1] === '1'
          const template = aIE[o].split('-')[0]
          const obj = { template: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.printSettingIE.push(obj)
          templateTypesIE.push(template)
        }
      }
      if (templateTypesIE.length > 0) {
        queryTemplatesByTypeMuti({ templateTypes: templateTypesIE, officeId: this.$store.getters.currentOfficeId }).then(res => {
          const result = res.data
          if (this.printSettingIE.length > 0) {
            for (const t in this.printSettingIE) {
              const curT = this.printSettingIE[t]
              if (curT) {
                const obj = result[curT.template]
                obj.uuid = getUuid()
                obj.path = curT.uuid + ',' + obj.uuid
                curT.children = true
              }
            }
            this.dgPrintIE.rowData = this.printSettingIE
          }
        })
      }
      // 锁定控制 - edi
      const ediSetting = this.configMap.get('creditBlockEDI') ? this.configMap.get('creditBlockEDI').toString() : ''
      const aEdi = ediSetting.split(',')
      if (aEdi && aEdi.length > 0) {
        for (const o in aEdi) {
          const lock = aEdi[o].split('-')[1] === '1'
          const template = aEdi[o].split('-')[0]
          const obj = { edi: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.ediSetting.push(obj)
        }
        this.dgEDI.rowData = this.ediSetting
      }

      // 锁定控制 - 单证
      const fileSetting = this.configMap.get('creditBlockFile') ? this.configMap.get('creditBlockFile').toString() : ''
      const aFile = fileSetting.split(',')
      if (aFile && aFile.length > 0) {
        for (const o in aFile) {
          const lock = aFile[o].split('-')[1] === '1'
          const template = aFile[o].split('-')[0]
          const obj = { file: template, selected: lock }
          obj.path = obj.uuid = getUuid()
          this.fileSetting.push(obj)
        }
        this.dgFile.rowData = this.fileSetting
      }
    },
    // 通知提醒数据源组装
    creditAlertRolesDataStruct(setting, event, config, childEvent = null) {
      const a = setting.split(',')
      const d = { name: event, config: config }
      d.path = d.uuid = getUuid()

      if (a && a.length > 1) {
        d.children = true // 保存时使用
        for (const o in a) {
          const child = { name: childEvent || event, target: a[o].split('-')[0], type: a[o].split('-')[1], config: config }
          child.uuid = getUuid()
          child.path = d.uuid + ',' + child.uuid
          this.alertSetting.push(child)
        }
      } else if (a && a.length === 1) {
        d.target = a[0].split('-')[0]
        d.type = a[0].split('-')[1]
      }
      this.alertSetting.push(d)
      this.adAlert.rowData = this.alertSetting
    },
    controlDisplay() {
      if (this.lob === 'SE') {
        this.vgLock = true
        this.tnLock1 = true
        this.tnLock2 = false
        this.tnLock3 = false
        this.tnLock4 = false
        this.tnLock5 = false
        this.tnLock6 = false
        this.tnLock7 = false
        this.dgOrderTakingSE.rowData = this.orderTakingSE = this.changeOrderTaking()
        this.dgCargoDocSE.rowData = this.cargoDocSE = this.setCargoDocSE()
      } else if (this.lob === 'SI') {
        this.vgLock = true
        this.tnLock1 = false
        this.tnLock2 = false
        this.tnLock3 = true
        this.tnLock4 = false
        this.tnLock5 = false
        this.tnLock6 = false
        this.tnLock7 = false
        this.dgOrderTakingSI.rowData = this.orderTakingSI = this.changeOrderTaking()
      } else if (this.lob === 'AE') {
        this.vgLock = true
        this.tnLock1 = false
        this.tnLock2 = true
        this.tnLock3 = false
        this.tnLock4 = false
        this.tnLock5 = false
        this.tnLock6 = false
        this.tnLock7 = false
        this.dgOrderTakingAE.rowData = this.orderTakingAE = this.changeOrderTaking()
      } else if (this.lob === 'AI') {
        this.vgLock = true
        this.tnLock1 = false
        this.tnLock2 = false
        this.tnLock3 = false
        this.tnLock4 = true
        this.tnLock5 = false
        this.tnLock6 = false
        this.tnLock7 = false
        this.dgOrderTakingAI.rowData = this.orderTakingAI = this.changeOrderTaking()
      } else if (this.lob === 'RE') {
        this.vgLock = true
        this.tnLock1 = false
        this.tnLock2 = false
        this.tnLock3 = false
        this.tnLock4 = false
        this.tnLock5 = true
        this.tnLock6 = false
        this.tnLock7 = false
        this.dgOrderTakingRE.rowData = this.orderTakingRE = this.changeOrderTaking()
      } else if (this.lob === 'RI') {
        this.vgLock = true
        this.tnLock1 = false
        this.tnLock2 = false
        this.tnLock3 = false
        this.tnLock4 = false
        this.tnLock5 = false
        this.tnLock6 = true
        this.tnLock7 = false
        this.dgOrderTakingRI.rowData = this.orderTakingRI = this.changeOrderTaking()
      } else if (this.lob === 'IE') {
        this.vgLock = true
        this.tnLock1 = false
        this.tnLock2 = false
        this.tnLock3 = false
        this.tnLock4 = false
        this.tnLock5 = false
        this.tnLock6 = false
        this.tnLock7 = true
        this.dgOrderTakingIE.rowData = this.orderTakingIE = this.changeOrderTaking()
      }
    },
    changeOrderTaking() {
      const list = []
      const obj = {}
      obj.controlObject = this.$t('CargoMsg.Cargo_NewOrCopyJob')
      obj.type = this.creditControlType()
      list.push(obj)
      return list
    },
    setCargoDocSE() {
      const list = []
      let obj = {}
      obj.typeName = '只有HBL'
      obj.type = this.cargoDocTypeFunc('HBL')
      list.push(obj)
      obj = {}
      obj.typeName = '只有MBL'
      obj.type = this.cargoDocTypeFunc('MBL')
      list.push(obj)
      obj = {}
      obj.typeName = 'HBL & MBL同时有'
      obj.type = this.cargoDocTypeFunc('HBLAndMBL')
      list.push(obj)
      this.dgCargoDocSE.tableData = [
        {
          typeName: '只有HBL',
          type: this.cargoDocTypeFunc('HBL')
        },
        {
          typeName: '只有MBL',
          type: this.cargoDocTypeFunc('MBL')
        },
        {
          typeName: 'HBL & MBL同时有',
          type: this.cargoDocTypeFunc('HBLAndMBL')
        }
      ]
      return list
    },
    creditControlType() {
      if (this.configMap.has('creditControlType' + this.lob)) {
        const creditControlType = this.configMap.get('creditControlType' + this.lob)
        return creditControlType && creditControlType.toString() === '1' ? '1' : '0'
      }
      return '0'
    },
    cargoDocTypeFunc(type) {
      if (this.configMap.has('creditCargoDocType' + type + this.lob)) {
        return this.configMap.get('creditCargoDocType' + type + this.lob)
      }
      return '0'
    },
    // 通知对象
    alertTargetLabelFunc(target) {
      if (!target) { return '' }
      if (target === 'op') { return this.$t('CargoMsg.Cargo_Operation') } else if (target === 'sales') { return this.$t('CargoMsg.Cargo_Sales') } else if (target === 'csr') { return this.$t('CargoMsg.Cargo_CustomerService') } else if (target === 'opmgr') { return this.$t('CargoMsg.Cargo_OperationExecutive') } else if (target === 'salesmgr') { return this.$t('CargoMsg.Cargo_SalesExecutive') } else if (target === 'creditmgr') { return this.$t('CargoMsg.Cargo_CreditControlSupervisor') } else if (target === 'overseas') { return this.$t('CargoMsg.Cargo_DestinationAgent1') } else if (target === 'jobcsr') { return this.$t('CargoMsg.Cargo_BusinessCustomerService') }
      return ''
    },
    // 通知方式
    alertTypeFunction(type) {
      if (!type && type !== 0) return ''
      if (type === '0') { return this.$t('CargoMsg.Cargo_EmailsAndReminders') } else if (type === '1') { return this.$t('CargoMsg.Cargo_Email2') } else if (type === '2') { return this.$t('CargoMsg.Cargo_Prompt') }
      return ''
    },
    // 打印模板
    templateTypeFunction(item) {
      if (item.children) {
        if (item.template === 'MBL') { return 'MBL页签打印' } else if (item.template === 'MBL2') { return 'MBL拆单/并单打印' } else if (item.template === 'HBLZB') { return 'HBL正本打印' } else if (item.template === 'HBL2ZB') { return 'HBL拆单/并单正本打印' } else if (item.template === 'HBLDF') { return 'HBL电放打印' } else if (item.template === 'HBL2DF') { return 'HBL拆单/并单电放打印' } else if (item.template === 'BOOKING') { return '订舱页签打印' }
      }
      return item.name
    },
    // 是否锁定
    booleanColumnLabelFunc(item) {
      if (!item) return ''
      return item.selected ? '√' : ''
    },
    alertControlTypeFunction(item) {
      if (!item) return ''
      const type = item.type
      if (type === '0') { return this.$t('CargoMsg.Cargo_LockAfterSaving') } else if (type === '1') { return this.$t('CargoMsg.Cargo_CannotBeSaved') }
      return '0'
    },
    // 空运出口的打印
    templateAETypeFunction(item) {
      if (!item) return ''
      if (item.children) {
        if (item.template === 'BASIC') { return '基本页签' } else if (item.template === 'MAWB') { return 'MAWB页签' } else if (item.template === 'HAWB') { return 'HAWB页签' }
      }
      return item.name
    },
    // 铁路出口的打印
    templateRETypeFunction(item) {
      if (!item) return ''
      if (item.children) {
        if (item.template === 'BASIC') { return this.$t('SeaExport.BasicTab') }
      }
      return item.name
    },
    // 铁路进口的打印
    templateRITypeFunction(item) {
      if (!item) return ''
      if (item.children) {
        if (item.template === 'BASIC') { return this.$t('SeaExport.BasicTab') }
      }
      return item.name
    },
    // 铁路进口的打印
    templateIETypeFunction(item) {
      if (!item) return ''
      if (item.children) {
        if (item.template === 'BASIC') { return this.$t('SeaExport.BasicTab') }
      }
      return item.name
    },
    // EDI
    ediTypeFunction(item) {
      if (!item) return ''
      if (item.edi === 'booking') { return '订舱EDI' } else if (item.edi === 'bl') { return '提单EDI' }
      return ''
    },
    // 单证
    fileTypeFunction(item) {
      if (!item) return ''
      return item.file === 'back' ? '退单' : ''
    },
    // 放单
    cargoDocTypeLabelFunc(item) {
      if (!item) return ''
      if (item.type === '0') {
        return this.$t('CargoMsg.Cargo_NoLock')
      }
      if (item.typeName === '只有HBL') {
        if (item.type === '1') {
          return '只有HBL扣HBL'
        }
      } else if (item.typeName === '只有MBL') {
        if (item.type === '1') {
          return '只有MBL扣MBL'
        }
      } else if (item.typeName === 'HBL & MBL同时有') {
        if (item.type === '1') {
          return 'HBL、MBL同时扣'
        } else if (item.type === '2') {
          return '只扣HBL不扣MBL'
        } else if (item.type === '3') {
          return '不扣HBL只扣MBL'
        }
      }
      return '异常状态'
    },
    onAdvSelectEnter(e) {}
  }
}
</script>

